import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type CategoryCharacteristicFilter as SchemaCategoryCharacteristicFilter } from '../schemas/CategoryCharacteristicFilter';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Categories
 */
export const GetCategoryCharacteristicFiltersContentType = '' as const;
export type GetCategoryCharacteristicFiltersRequest = void;
export type GetCategoryCharacteristicFiltersResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful retrieval of data
     */
    '200': {
        'application/json': SchemaCategoryCharacteristicFilter[];
    };
};
export type GetCategoryCharacteristicFiltersResponseSuccess =
    GetCategoryCharacteristicFiltersResponses['200']['application/json'];
export type GetCategoryCharacteristicFiltersSearchParams = undefined;
export type GetCategoryCharacteristicFiltersPathParameters = {
    category_id: string;
};
export const GetCategoryCharacteristicFiltersUrl = '/categories/{category_id}/characteristics' as const;
export const GetCategoryCharacteristicFiltersMethod = 'GET' as const;
export const getGetCategoryCharacteristicFiltersUrl = (params: GetCategoryCharacteristicFiltersPathParameters) =>
    GetCategoryCharacteristicFiltersUrl.replace(
        /\{(\w+)\}/g,
        (_match, param: keyof GetCategoryCharacteristicFiltersPathParameters) => String(params[param])
    );
